import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import { AuthService } from 'src/app/Services/auth.service';
import * as alertify from "alertifyjs";
import { ConfirmDialogComponent } from 'src/app/Shared/shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {

  @Output() onConfirmClicked = new EventEmitter();
  email: string;
  verifyForm: any = FormGroup;
  saving:  boolean = false;
  errorMessage: string;

  eyeOpen: boolean = false;
  eyeOpenConfirm: boolean = false;


  ngOnInit(): void {
    this.verifyForm = this.fb.group({
      old: ["", [Validators.required]],
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/
          ),
        ],
      ],
      confirm: ["", [Validators.required]],
    });
  }

  toggleEye() {
    this.eyeOpen = !this.eyeOpen;
  }
  toggleEyeConfirm() {
    this.eyeOpenConfirm = !this.eyeOpenConfirm;
  }

  close() {
    this.onConfirmClicked.emit();
  }

  constructor(
      private authenticationService: AuthService,
      private apiService: ApiServiceService,
      private fb: FormBuilder,
      private bsModalService: BsModalService,
      private bsModalRef: BsModalRef,
  ) {
  }

  confirmSave(){

    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Proceed to change password",
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
    this.submit()
      dfModalRef.hide();
    });
  

}

  submit() {

    this.saving = true
    this.email = this.authenticationService.getEmail();
  
    const req = {
      email: this.email,
      newPassword: this.verifyForm.value?.password,
      oldPassword: this.verifyForm.value?.old
    };
  
    if (!this.checkPassword()) return;
  
    const url = '/auth/user/change-password';
    this.apiService.loginPost_(url, req).subscribe(
      (response) => {

        this.verifyForm.reset()

        
        this.bsModalRef.hide();
        alertify.set('notifier', 'position', 'top-right');
        alertify.success(response.message); 

        
  
        
        setTimeout(() => {
          this.authenticationService.logout();
        }, 2500);
      },
      (error) => {
        alertify.set('notifier', 'position', 'top-right');
        alertify.error("Old password is incorrect. Please try again");
        this.saving = false
      }
    );
  }
  

  checkPassword() {
    if (this.verifyForm.value.password !== this.verifyForm.value.confirm) {
      this.errorMessage = "Passwords do not match";
      return false;
    }
    this.errorMessage = "";
    return true;
  }
}
